import {css} from '@emotion/css';
import {useTheme} from '@mui/material';
import {SnackbarProvider, enqueueSnackbar} from 'notistack';
import React, {useCallback, useEffect} from 'react';
import {useSelector} from 'react-redux';
import AlertSnackbar from './AlertSnackbar.jsx';
import dimensions from '@app/styles/dimensions.js';

const Notifier = () => {
  const theme = useTheme();

  const classes = {
    containerAnchorOriginTopCenter: css({
      zIndex: theme.zIndex.modal + 1,
      top: dimensions.topNav.height,
    }),
  };

  const notification = useSelector(state => state.notifications.notification);

  const onShowNotification = useCallback(() => {
    if (notification) {
      const altKey =
        typeof notification.message === 'string'
          ? notification.message
          : `${new Date().getTime() + Math.random()}`;

      enqueueSnackbar(altKey, {
        ...notification,
        variant: notification.severity || 'info',
      });
    }
  }, [notification]);

  useEffect(onShowNotification, [notification, onShowNotification]);

  return (
    <SnackbarProvider
      classes={classes}
      preventDuplicate
      Components={{
        default: AlertSnackbar,
        error: AlertSnackbar,
        success: AlertSnackbar,
        warning: AlertSnackbar,
        info: AlertSnackbar,
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    />
  );
};

export default Notifier;
